module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "fronttitle paired"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('a', {
    attrs: {
      "href": "#/contents"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('a', {
    attrs: {
      "href": "#/front03"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("JENNY BHATT: Return to India")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("CHRISTOPHER BOLLEN: SWAJ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NIKKI DOLSON: Neighbors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. GABRIEL FLORES: Mala Suerte")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALISON GAYLIN: Where I Belong")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GAR ANTHONY HAYWOOD: With Footnotes and References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAVI HOWARD: The Good Thief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GABINO IGLESIAS: Everything Is Going to Be Okay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARIS JONES: Green-Eyed Monster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRESTON LANG: Potato Sandwich Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AYA DE LEÓN: Frederick Douglass Elementary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KRISTEN LEPIONKA: Infinity Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAURA LIPPMAN: Slow Burner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOANNA PEARSON: Mr. Forble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DELIA C. PITTS: The Killer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELIOT SCHREFER: Wings Beating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALEX SEGURA: 90 Miles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRIAN SILVERMAN: Land of Promise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAYE SNOWDEN: One Bullet. One Vote.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LISA UNGER: Let Her Be")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors’ Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Distinguished Mystery and Suspense of 2020")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/back03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read More from the Best American Series")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/back04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc sub"
  }, [_c('span', {
    attrs: {
      "href": "#/back05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connect on Social Media")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0